 


// class VariantSelector extends HTMLElement {
//     constructor() {
//         super();
   
//         const params = new URLSearchParams(window.location.search);
//         this.variant = params.get('variant');
//         this.url = this.dataset.url ? this.dataset.url  : "mitopets-pad"
//         this.FeaturedPrice = this.querySelector('.price-item2')
//         this.CurrentPrice = document.querySelector('.price-item')
//         this.productId = document.querySelector('.product-variant-id')
//         this.pet_product_id = document.querySelector('.product-variant-id-2')
//      this.data ;
//         this.currency = this.CurrentPrice.innerText.match(/^([^\d]+)?([\d.,]+)/);
//           this.buyButton = document.querySelector('.product-form__buttons > button')
//     }

//     connectedCallback() {

//         this.rawdata = this.querySelector('script')?.innerText
//         this.parent = this.querySelector('.grp-insert')

       
//         if (this.rawdata !== undefined) {
      
//            this.data = JSON.parse(this.rawdata);
       
//           const { meta } = this.data;
//             if (Object.keys(this.data).length > 0) this.GroupedMetaData(meta)
//         }

//         this.options = this.querySelectorAll('button');

//         if (this.options.length > 1) {
//             this.onloadCheck()
//             this.addListeners();
//         } else {
//             this.getVariantImages()
//         }
//     }

//     addListeners() {

//         this.options.forEach(option => {
//             option.addEventListener('click', () => {
  
//                 !option.classList.contains('pets_var') && window.history.replaceState({}, '', `${this.url}?variant=${option.dataset.variantId}`);
//                 this.clearSelection()
//                 option.classList.add('is-selected');
//                 if (option.classList.contains('pets_var')) {
//                     this.FeaturedPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
//                     this.pet_product_id.value = option.dataset.variantId
//                 } else {
                
//                     this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
//                     this.productId.value = option.dataset.variantId
//                      const filterVariant = this.data.variants.filter((variant)=> variant.id === Number(this.productId.value) )
//                     console.log(filterVariant)
                
//                   if(filterVariant['0'].available ){
              
//                       this.buyButton.disabled = false;
//                     this.buyButton.textContent = "+ Add to Cart"
               
                
//                   }else{
                    
//                     this.buyButton.disabled = true;
//                     this.buyButton.textContent = "Sold Out"
                       
//                   }
               
             
//                 }

//                option.dataset.variantAlt && this.getVariantImages(option.dataset?.variantAlt.trim())
//             });
//         });
//     }

//     clearSelection() {

//         this.options.forEach(option => {
//             option.classList.remove('is-selected');
//         });
//     }

//     onloadCheck() {
    

//         this.options.forEach(option => {
//             if (option.classList.contains('is-selected') && option.dataset.variantAlt && option.dataset.variantId  ) {

//                 window.history.replaceState({}, '', `${this.url}?variant=${option.dataset.variantId}`);
//                this.getVariantImages(option.dataset?.variantAlt.trim())
//                this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
//             }
//             else if (option.classList.contains('is-selected') ) {
//                 if (option.classList.contains('pets_var')) {
//                     this.FeaturedPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
//                     this.pet_product_id.value = option.dataset.variantId
//                 } else {
//                     this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
//                     this.productId.value = option.dataset.variantId
//                     this.getVariantImages()
//                     option.dataset.variantAlt && this.getVariantImages(option.dataset?.variantAlt.trim())
//                 }

//             }
//         });

//     }

//     getVariantImages(variant) {
//         const title = document.querySelector('.product-title').textContent
//         let images = document.querySelectorAll('.product__gallery__main__media')
//         if (variant !== undefined) {
//             images.forEach((image,index) => {
//                 let str = image.dataset.alt.trim()
//                 if (str === variant || str === title) {

//                        image.classList.remove('hidden');
//                         document.getElementById(`${image.dataset.mediaId}`).style.display="block"
//                    } else {

//                        image.classList.add('hidden');
//                        document.getElementById(`${image.dataset.mediaId}`).style.display="none"
//                  }
//                });

//                // Mark all activeimages with a index number
//                let activeImages = [...images]?.filter((image) => image.classList.contains('hidden') == false);
//                activeImages.forEach((image, index) => {
//                  image.dataset.index = index;
//                });
//         }
//         else {
//             images.forEach((image) => {
//                   image.classList.remove('hidden');
//                 document.getElementById(`${image.dataset.mediaId}`).style.display="block"
//                });

//         }
//     }

//     GroupedMetaData(meta) {
          
//         let groupedMeta = meta.reduce((acc, item , index , arr) => {
//             // Use the option_group value as the key
//             let key = item.option_group;

//             // If an array already present for key, push it to the array. Else, create an array and push it
//             if (!acc[key]) {
//               acc[key] = [];
//             }
//             acc[key].push(item);

//             // Return the modified object
//             return acc;
//         }, {});

       
//         if (Object.keys(groupedMeta).length > 1) {
//             this.PrintTitle(groupedMeta)
//         } else if (meta.length > 1){
//             const parentElement = $(this.querySelector('.display-flex'));
//                 const $parentGroup  = $(`<div > </div>`)
//              const $Group = $(
//                 `   <div class="buttons-group">
//                  </div>
//                 ` )
//                 parentElement.append($parentGroup)

//             meta.forEach((ele,index) => {
              
//                 document.querySelector('.price-item');
//                 if (index === 0 && parentElement.find('.is-selected').length === 0 && !this.variant) {
//                     $Group.append(`
//                         <button class="is-selected " data-price=${ele.price} data-variant-id=${ele.variant_id}
//                          data-variant-alt="${ele.featured_image}">${ele.title}</button>
//                     `);
//                 }else if(this.variant && ele.variant_id === this.variant ){
//                         $Group.append(`
//                         <button class="is-selected " data-price=${ele.price} data-variant-id=${ele.variant_id}
//                          data-variant-alt="${ele.featured_image}">${ele.title}</button>
//                     `);
//                 }
//                 else {
//                     $Group.append(`
//                     <button data-price=${ele.price} data-variant-id=${ele.variant_id} data-variant-alt="${ele.featured_image}">${ele.title}</button>
//                 `);
//                 }


//             });
//             $parentGroup.append($Group)
//         }

//     }

//     PrintTitle(groupedData) {
//         const parentElement = $(this.querySelector('.display-flex')); // Cache the parent element

//         for (const property in groupedData) {
//             const content = property === "null" ? " " : property;
//             const $parentGroup = $(
//                 `   <div >
//                 <p class="buy-buttons-group">${content}</p>
//                  </div>
//                 ` )

//             const $Group = $(
//                 `   <div class="buttons-group ">
//                  </div>
//                 ` )

//             parentElement.append($parentGroup);


//             groupedData[property].forEach((item, index) => {
              
//                 document.querySelector('.price-item')
           
//                 if (index === 0 && parentElement.find('.is-selected').length === 0 &&  !this.variant) {
                  
//                     $Group.append(`
//                     <div class="variant-btn" >
//                         <button class="is-selected " data-price=${item.price}  data-variant-id="${item.variant_id}"
//                        data-variant-alt="${item.featured_image}" >${item.title}</button>
//   <div/>
//                     `);
//                 }else if( this.variant && item.variant_id === this.variant  ){
//                      $Group.append(`
//                     <div class="variant-btn" >
//                         <button class="is-selected " data-price=${item.price}  data-variant-id="${item.variant_id}"
//                        data-variant-alt="${item.featured_image}" >${item.title}</button>
//   <div/>
//                     `);
//                 }
//                 else {
//                     $Group.append(`
//                     <div class="variant-btn" >
//                     <button data-price=${item.price} data-variant-id="${item.variant_id}" data-variant-alt="${item.featured_image}" >${item.title}</button>
//                     <div/>
//                     `);
//                 }
//             });

//             $parentGroup.append($Group)
//             }

//     }


//  formatPrice(priceInCents) {
       
//         const dollars = priceInCents / 100;

  
//         return `${this.currency[1]} ${dollars.toLocaleString("en-US")}`;
//       }


// };


// customElements.define('custom-variant-selector', VariantSelector);
// new updated code for UTM tag wipe out fix--above is the old code
class VariantSelector extends HTMLElement {
  constructor() {
    super();

    const params = new URLSearchParams(window.location.search);
    this.variant = params.get('variant');
    this.url = this.dataset.url ? this.dataset.url : "mitopets-pad";
    this.FeaturedPrice = this.querySelector('.price-item2');
    this.CurrentPrice = document.querySelector('.price-item');
    this.productId = document.querySelector('.product-variant-id');
    this.pet_product_id = document.querySelector('.product-variant-id-2');
    this.data;
    this.currency = this.CurrentPrice.innerText.match(/^([^\d]+)?([\d.,]+)/);
    this.buyButton = document.querySelector('.product-form__buttons > button');
  }

  connectedCallback() {
    this.rawdata = this.querySelector('script')?.innerText;
    this.parent = this.querySelector('.grp-insert');

    if (this.rawdata !== undefined) {
      this.data = JSON.parse(this.rawdata);
      const { meta } = this.data;
      if (Object.keys(this.data).length > 0) this.GroupedMetaData(meta);
    }

    this.options = this.querySelectorAll('button');

    if (this.options.length > 1) {
      this.onloadCheck();
      this.addListeners();
    } else {
      this.getVariantImages();
    }
  }

  addListeners() {
    this.options.forEach(option => {
      option.addEventListener('click', () => {

        // UTM-SAFE VARIANT URL UPDATE
        if (!option.classList.contains('pets_var')) {
          const currentParams = new URLSearchParams(window.location.search);
          currentParams.set('variant', option.dataset.variantId);
          const newUrl = `${this.url}?${currentParams.toString()}`;
          window.history.replaceState({}, '', newUrl);
        }
        // ENDing OF UTM FIX

        this.clearSelection();
        option.classList.add('is-selected');

        if (option.classList.contains('pets_var')) {
          this.FeaturedPrice.innerText = this.formatPrice(option.getAttribute('data-price'));
          this.pet_product_id.value = option.dataset.variantId;
        } else {
          this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'));
          this.productId.value = option.dataset.variantId;
          const filterVariant = this.data.variants.filter((variant) => variant.id === Number(this.productId.value));

          if (filterVariant[0].available) {
            this.buyButton.disabled = false;
            this.buyButton.textContent = "+ Add to Cart";
          } else {
            this.buyButton.disabled = true;
            this.buyButton.textContent = "Sold Out";
          }
        }

        option.dataset.variantAlt && this.getVariantImages(option.dataset?.variantAlt.trim());
        // ADD THIS BLOCK (VERY IMPORTANT) For Custom addons variants meatfeilds
const variantId = option.dataset.variantId;

fetch(window.location.pathname + "?variant=" + variantId)
  .then(res => res.text())
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const newAddons = doc.querySelector("#variant-addons-wrapper");
    const currentAddons = document.querySelector("#variant-addons-wrapper");

    if (newAddons && currentAddons) {
      currentAddons.innerHTML = newAddons.innerHTML;
    }
  });
      });
    });
  }

  clearSelection() {
    this.options.forEach(option => {
      option.classList.remove('is-selected');
    });
  }

  onloadCheck() {
    this.options.forEach(option => {
      if (option.classList.contains('is-selected') && option.dataset.variantAlt && option.dataset.variantId) {

        // UTM-SAFE URL UPDATE ON PAGE LOAD
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('variant', option.dataset.variantId);
        const newUrl = `${this.url}?${currentParams.toString()}`;
        window.history.replaceState({}, '', newUrl);
        //  END OF FIX

        this.getVariantImages(option.dataset?.variantAlt.trim());
        this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'));
      } else if (option.classList.contains('is-selected')) {
        if (option.classList.contains('pets_var')) {
          this.FeaturedPrice.innerText = this.formatPrice(option.getAttribute('data-price'));
          this.pet_product_id.value = option.dataset.variantId;
        } else {
          this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'));
          this.productId.value = option.dataset.variantId;
          this.getVariantImages();
          option.dataset.variantAlt && this.getVariantImages(option.dataset?.variantAlt.trim());
        }
      }
    });
  }

  getVariantImages(variant) {
    const title = document.querySelector('.product-title').textContent;
    let images = document.querySelectorAll('.product__gallery__main__media');

    if (variant !== undefined) {
      images.forEach((image) => {
        let str = image.dataset.alt.trim();
        if (str === variant || str === title) {
          image.classList.remove('hidden');
          document.getElementById(`${image.dataset.mediaId}`).style.display = "block";
        } else {
          image.classList.add('hidden');
          document.getElementById(`${image.dataset.mediaId}`).style.display = "none";
        }
      });

      let activeImages = [...images]?.filter((image) => !image.classList.contains('hidden'));
      activeImages.forEach((image, index) => {
        image.dataset.index = index;
      });
    } else {
      images.forEach((image) => {
        image.classList.remove('hidden');
        document.getElementById(`${image.dataset.mediaId}`).style.display = "block";
      });
    }
  }

  GroupedMetaData(meta) {
    let groupedMeta = meta.reduce((acc, item) => {
      let key = item.option_group;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

    if (Object.keys(groupedMeta).length > 1) {
      this.PrintTitle(groupedMeta);
    } else if (meta.length > 1) {
      const parentElement = $(this.querySelector('.display-flex'));
      const $parentGroup = $(`<div></div>`);
      const $Group = $(`<div class="buttons-group"></div>`);
      parentElement.append($parentGroup);

      meta.forEach((ele, index) => {
        if (index === 0 && parentElement.find('.is-selected').length === 0 && !this.variant) {
          $Group.append(`
            <button class="is-selected" data-price=${ele.price} data-variant-id=${ele.variant_id}
             data-variant-alt="${ele.featured_image}">${ele.title}</button>
          `);
        } else if (this.variant && ele.variant_id === this.variant) {
          $Group.append(`
            <button class="is-selected" data-price=${ele.price} data-variant-id=${ele.variant_id}
             data-variant-alt="${ele.featured_image}">${ele.title}</button>
          `);
        } else {
          $Group.append(`
            <button data-price=${ele.price} data-variant-id=${ele.variant_id} data-variant-alt="${ele.featured_image}">${ele.title}</button>
          `);
        }
      });
      $parentGroup.append($Group);
    }
  }

  PrintTitle(groupedData) {
    const parentElement = $(this.querySelector('.display-flex'));
    for (const property in groupedData) {
      const content = property === "null" ? " " : property;
      const $parentGroup = $(`
        <div>
          <p class="buy-buttons-group">${content}</p>
        </div>
      `);
      const $Group = $(`<div class="buttons-group"></div>`);
      parentElement.append($parentGroup);

      groupedData[property].forEach((item, index) => {
        if (index === 0 && parentElement.find('.is-selected').length === 0 && !this.variant) {
          $Group.append(`
            <div class="variant-btn">
              <button class="is-selected" data-price=${item.price} data-variant-id="${item.variant_id}"
                data-variant-alt="${item.featured_image}">${item.title}</button>
            </div>
          `);
        } else if (this.variant && item.variant_id === this.variant) {
          $Group.append(`
            <div class="variant-btn">
              <button class="is-selected" data-price=${item.price} data-variant-id="${item.variant_id}"
                data-variant-alt="${item.featured_image}">${item.title}</button>
            </div>
          `);
        } else {
          $Group.append(`
            <div class="variant-btn">
              <button data-price=${item.price} data-variant-id="${item.variant_id}"
                data-variant-alt="${item.featured_image}">${item.title}</button>
            </div>
          `);
        }
      });

      $parentGroup.append($Group);
    }
  }

  formatPrice(priceInCents) {
    const dollars = priceInCents / 100;
    return `${this.currency[1]} ${dollars.toLocaleString("en-US")}`;
  }
}

customElements.define('custom-variant-selector', VariantSelector);
// Custom metafields adds on logic
